// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__7mVVR","vacancies":"Modal_vacancies__ini+2"};